import ClubMemberAccessMediumIntraKey from '../dto/ClubMemberAccessMediumIntraKey';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubMemberAccessMediumIntraKeyRepository {
    static find(memberId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/members/${memberId}/access-mediums/intra-key`)
                .then((response) => resolve(response.data.data.map((data) => ClubMemberAccessMediumIntraKey.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static create(memberId, clubMemberAccessMedium) {
        const data = {
            identifier: clubMemberAccessMedium.identifier,
            accessMediumType: Number(clubMemberAccessMedium.accessMediumType),
            permission: clubMemberAccessMedium.permission !== null ? clubMemberAccessMedium.permission.id : null,
        };
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/members/${memberId}/access-mediums/intra-key`, data)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(accessMediumId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/club-member-access-mediums/${accessMediumId}/intra-key`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(clubMemberAccessMediums) {
        return Promise.all(clubMemberAccessMediums.map((clubMemberAccessMedium) => {
            const data = {
                identifier: clubMemberAccessMedium.identifier,
                accessMediumType: Number(clubMemberAccessMedium.accessMediumType),
                permission: clubMemberAccessMedium.permission !== null ? clubMemberAccessMedium.permission.id : null,
            };
            return new Promise((resolve, reject) => {
                axios
                    .put(`/club/club-member-access-mediums/${clubMemberAccessMedium.id}/intra-key`, data)
                    .then(() => resolve())
                    .catch((error) => reject(Error.fromResponse(error.response)));
            });
        }));
    }
}
